import React, { useEffect, useState } from 'react'
import styles from './tarot_astro_signup.module.css'
import TextField from "@mui/material/TextField";
import {
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Link,
  Button,
  FormHelperText,
  InputBase,
  LinearProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useRouter } from 'next/router';
import Head from 'next/head';

export default function Index() {

  
    const [user, setUser] = useState({})
    const [error, setError] = useState({})
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = React.useState(false);
    const [showpass , setShowpass] = useState(false)
    const [showcpass , setShowcpass] = useState(false)
    const [loader , setLoader] = useState(false)
    const [snackbarStare , setSnackbarStare] = useState(false)
    const [message , setMessage] = useState()
    const router = useRouter()

    const handleInput = (e) => {

      let name = e.target.name;
      let value = e.target.value
      if (name === "state") {
  
        setError({ ...error, [name]: undefined })
      }
  
      setUser({ ...user, [name]: value })
  
    }

      // <--------------------------- Phone Formating --------------------------->
  const phoneFormatting = (event) => {
    // console.log("event", event)
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      user.phone = formatted
      setUser({ ...user, [name]: formatted })
    }
  }

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");

    if (value.length > 3 && value.length <= 6) value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6) value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3, 6) + "-" + value.slice(6);
    return value;
  }


  const showPass = (e)=>{
    console.log("test", e);
    if (e=='pass') {
      setShowpass(!showpass)      
    }else{
      setShowcpass(!showcpass) 
    }
  }














  useEffect(() => {
    console.log(user)
  }, [user])
  const handleSubmit = async (e) => {
    e.preventDefault()
    let errorObject = {}


    if (!user?.firstname) {
      errorObject.firstname = "First Name is Required"
    }
    if (!user?.email) {
      errorObject.email = "Email is Required"

    }
    else if (!/\S+@\S+\.\S+/.test(user.email)) {
      errorObject.email = '* Invalid email format';
    }
    if (!user?.lastname) {
      errorObject.lastname = "Last Name is Required"
    }
    if (!user?.city) {
      errorObject.city = "City is Required"
    }
    if (!user?.phone) {
      errorObject.phone = " Telephone Number is Required"
    }

    if (!user?.state) {
      errorObject.state = "State is Required"
    }
    if (!user?.gender) {
      errorObject.gender = "Gender is Required"
    }
    if (!user?.password) {
      errorObject.password = "Password is Required"
    }
    else if (!(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,15}$/.test(user.password))) {
      errorObject.password = "* Invalid Password"
    }
    if (!user?.confirm_password) {
        errorObject.confirm_password = "Confirm Password is Required"
      }

      if (user?.password!==user?.confirm_password) {
        errorObject.confirm_password = "password and Confirm Password does not match"
      }
    // if (!user?.comments) {
    //   errorObject.comments = "Questions Or Comments is Required"
    // }
    if (!user?.zip) {
      errorObject.zip = "Zip is Required"
    }
    if (Object.keys(errorObject).length > 0) {
      setError(errorObject)
      console.log("error exeist", errorObject);
    }
    else {
      setUser({ ...user, ["phone"]: user.phone.replace(/^\((.+)\)$/, "") })
      setLoader(true)


      setError({})
      let requestOptions = {
        method: 'POST',
        // mode:'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
      }
      console.log(user)
      try {
        let req = await fetch(`${process.env.backend_url}user/signup`, requestOptions)
        console.log("req", req);
        let res = await req.json()
        if (res.status==='success') {
          console.log("res status=======>", res);
          setSnackbarStare(true)    
          setMessage(res.message)
          setUser(null)  
          router.push(`/thankyou/${res.results._id}`)
          setLoader(false)
        }else{
          console.log("res error=======>", res);
          setSnackbarStare(true)    
          setMessage(res.message)
          setLoader(false)
        }
        
        
       

      } catch (error) {
        console.log(error, "this is submit error");
        setLoader(false)
      }
      // setLoader(false)
      // setUser(null)
      console.log("kjhkjh", user)


    }
  }





  const StateArray = [
    {
      name: "Alabama",
      val: "AL",
    },
    {
      name: "Alaska",
      val: "AK",
    },
    {
      name: "Arizona",
      val: "AZ",
    },
    {
      name: "Arkansas",
      val: "AR",
    },
    {
      name: "California",
      val: "CA",
    },
    {
      name: "Colorado",
      val: "CO",
    },
    {
      name: "Connecticut",
      val: "CT",
    },
    {
      name: "Delaware",
      val: "DE",
    },
    {
      name: "Florida",
      val: "FL",
    },
    {
      name: "Georgia",
      val: "GA",
    },
    {
      name: "Hawaii",
      val: "HI",
    },
    {
      name: "Idaho",
      val: "ID",
    },
    {
      name: "Illinois",
      val: "IL",
    },
    {
      name: "Indiana",
      val: "IN",
    },
    {
      name: "Iowa",
      val: "IA",
    },
    {
      name: "Kansas",
      val: "KS",
    },
    {
      name: "Kentucky",
      val: "KY",
    },
    {
      name: "Louisiana",
      val: "LA",
    },
    {
      name: "Maine",
      val: "ME",
    },
    {
      name: "Maryland",
      val: "MD",
    },
    {
      name: "Massachusetts",
      val: "MA",
    },
    {
      name: "Michigan",
      val: "MI",
    },
    {
      name: "Minnesota",
      val: "MN",
    },
    {
      name: "Mississippi",
      val: "MS",
    },
    {
      name: "Missouri",
      val: "MO",
    },
    {
      name: "Montana",
      val: "MT",
    },
    {
      name: "Nebraska",
      val: "NE",
    },
    {
      name: "Nevada",
      val: "NV",
    },
    {
      name: "New Hampshire",
      val: "NH",
    },
    {
      name: "New Jersey",
      val: "NJ",
    },
    {
      name: "New Mexico",
      val: "NM",
    },
    {
      name: "New York",
      val: "NY",
    },
    {
      name: "North Carolina",
      val: "NC",
    },
    {
      name: "North Dakota",
      val: "ND",
    },
    {
      name: "Ohio",
      val: "OH",
    },
    {
      name: "Oklahoma",
      val: "OK",
    },
    {
      name: "Oregon",
      val: "OR",
    },
    {
      name: "Pennsylvania",
      val: "PA",
    },
    {
      name: "Rhode Island",
      val: "RI",
    },
    {
      name: "South Carolina",
      val: "SC",
    },
    {
      name: "South Dakota",
      val: "SD",
    },
    {
      name: "Tennessee",
      val: "TN",
    },
    {
      name: "Texas",
      val: "TX",
    },
    {
      name: "Utah",
      val: "UT",
    },
    {
      name: "Vermont",
      val: "VT",
    },
    {
      name: "Virgin Islands",
      val: "VI",
    },
    {
      name: "Virginia",
      val: "VA",
    },
    {
      name: "Washington",
      val: "WA",
    },
    {
      name: "West Virginia",
      val: "WV",
    },
    {
      name: "Wisconsin",
      val: "WI",
    },
    {
      name: "Wyoming",
      val: "WY",
    },
  ];

  const GenderArray = [
    {
      name: "Male",
      val: "M",
    },
    {
      name: "Female",
      val: "F",
    },
    {
      name: "Others",
      val: "O",
    },
  ];
  return (
    <>


    <Head>
    <title>Join as a Tarot Reader And Astrologer | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Tarot Reader Jobs, Professional Astrologer, Join Our Team, Tarot Platform, Astrology Platform, Divine Theurgy, Oracle Readings, Client Management for Readers"
    ></meta>
    <meta
      property="og:title"
      content="Join Our Team of Professional Tarot Readers & Astrologers"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/tarot_astrologer_signup_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A signup form for professional tarot readers and astrologers to join the School of Our Divine Infinite Being, set against a cosmic background."
    ></meta>
    <meta
      property="og:description"
      content="Are you a gifted Tarot reader or seasoned Astrologer? Join our distinguished team to share your mystical light. Showcase your expertise, access professional tools, and connect with clients seeking profound insights."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/tarot-astro-signup"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/tarot_astrologer_signup_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A signup form for professional tarot readers and astrologers to join the School of Our Divine Infinite Being, set against a cosmic background."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/tarot-astro-signup"
    ></meta>
    <meta
      name="twitter:title"
      content="Join Our Team of Professional Tarot Readers & Astrologers"
    ></meta>
    <meta
      name="twitter:description"
      content="Are you a gifted Tarot reader or seasoned Astrologer? Join our distinguished team to share your mystical light. Showcase your expertise, access professional tools, and connect with clients seeking profound insights."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/tarot-astro-signup" />
</Head>
        
        <div className= {styles.divine_signup_page_main}>
          <div className={styles.divine_signup_page_cmmn_wdth}>

           
          <div className= {styles.divine_signup_page_main_flx}>

            <div className= {styles.divine_signup_page_left}>

              {/* <div className='sign_up_logo_wrpr'>
                <span><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/divine_sign_up_logo.webp"/></span>
                <h1 data-text="SCHOOL OF THE DIVINE">SCHOOL OF THE DIVINE</h1>
                <h1 data-text="SCHOOL OF THE DIVINE">INFINITE BEING</h1>
              </div> */}

              <div className={styles.divine_signup_page_left_top_sec}>

                <div className= {styles.divine_signup_page_left_sub_left}>
                  <div className= {styles.sign_up_logo_wrpr}>
                  <span>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/divine_sign_up_logo.webp"/> */}
                    <img src={`${process.env.cloud_url}sign_up/divine_sign_up_logo.webp`}/>
                  </span>
                  <div className={styles.sign_up_logo_txt}><h1 data-text="SCHOOL OF THE DIVINE" >SCHOOL OF THE DIVINE</h1>
                  <h1 data-text="SCHOOL OF THE DIVINE">INFINITE BEING</h1></div>
                   </div>
                </div>
  
                <div className= {styles.divine_signup_page_right_sub_right}>
                  <div className={styles.divine_signup_page_right_sub_right_sub}>
                      {/* <div className= {styles.divine_signup_page_right_sub_men}>
                          <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/sign_up/men_img.webp'/>
                      </div> */}
                      <div className= {styles.divine_signup_page_right_sub_txt}>
                        {/* <h4>Lorem Ipsum</h4>
                        <div className= {styles.divine_signup_page_phn_feild}>
                          <p>Lorem Ipsum@simply</p>
                          <p>0000 000 000</p>
                          <p>The printing, and typesetting industry453, Lorem </p>
                        </div> */}
                        <h4>The School of Our Divine Infinite Being</h4>
                        <p>Your Gateway to Polytheistic Monism, Divine Theurgy, and Oracle Readings to Become a Professional DIVINER.</p>
                      </div>
                  </div>
                </div>

              </div>

              <div className={styles.divine_signup_mddl_txt}>

                <p>Are you a gifted Tarot reader and a seasoned Astrologer, passionate about guiding souls on their transformative journeys? Divine Infinite Being extends a warm invitation to join our distinguished team.</p>
                <p>Whether you interpret the cards or read the stars, we welcome your wisdom. <span>Sign up today to shine your mystical light and empower others on their unique path.</span> Join us in the sacred mission of lighting up destinies through the profound arts of Tarot and Astrology!</p>

              </div>

              <div className={styles.divine_signup_last_sec}>
                <h5>Benefits of Joining Us:</h5>
                <div className={styles.divine_signup_last_sec_bullet}>

                  <p>Showcase your expertise in Tarot and Astrology on our platform</p>
                  <p>Connect with individuals seeking celestial and mystical insights</p>
                  <p>Full access to Tarot and Astrology tools</p>
                  <p>Access to backoffice for flexible scheduling and efficient client management</p>

                </div>

              </div>

            </div>

            <div className={styles.divine_signup_page_right}>

              <div className={styles.divine_signup_page_right_inn}>

                <div className={styles.divine_signup_page_right_form_hdr}>
                  <h2>SIGN UP HERE</h2>
                </div>

                <form>
                        <TextField
                          className={`${styles.from_input} ${styles.form_field_wrapperfname}`}
                          id="outlined-basic"
                          name="firstname"
                          value={user?.firstname ? user.firstname : ""}
                          onChange={handleInput}
                          error={error.firstname ? true : false}
                          helperText={error.firstname}
                          onKeyDown={() => { error.firstname = "" }}

                          // label="Email*"
                          variant="outlined"
                          label="First Name"
                        />
                        <TextField
                          className={`${styles.from_input} ${styles.form_field_wrapperlname}`}
                          id="outlined-basic"
                          name="lastname"
                          value={user?.lastname ? user.lastname : ""}
                          onChange={handleInput}
                          error={error?.lastname ? true : false}
                          helperText={error.lastname}
                          onKeyDown={() => { error.lastname = "" }}
                          // label="Email*"
                          variant="outlined"
                          label="Last Name"
                        />
                        
                          <TextField
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="email"
                            value={user?.email ? user.email : ""}
                            onChange={handleInput}
                            error={error.email ? true : false}
                            helperText={error.email}
                            onKeyDown={() => { error.email = "" }}
                            // label="Email*"
                            variant="outlined"
                            label="Email"
                          />

                          <TextField
                            label="Phone No"
                            className={`${styles.from_input} `}
                            variant="outlined"
                            fullWidth={true}
                            name="phone"
                            type="text"
                            onKeyPress={(e) => {
                              error.phone = ""
                              // console.log("this is number onkeydown=====", e.code, e.key, 'e.which', e.which);
                              if (e.which < 48 || e.which > 57) {
                                e.preventDefault();
                              }
                              else {
                                let input = e.target.value;
                                let result = input.replace(/\D/g, '');
                                console.log(input, result, "suyagudsa");
                              }
                            }}
                            onChange={(e) => phoneFormatting(e)}
                            value={user?.phone}
                            error={error?.phone ? true : false}
                            helperText={error?.phone}
                          />

                          {/* <TextField
                            label="Gender"
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="gender"
                            value={user?.gender ? user.gender : ""}
                            onChange={handleInput}
                            error={error.gender ? true : false}
                            helperText={error.gender}
                            onKeyDown={() => { error.gender = "" }}
                            label="Email*"
                            variant="outlined"
                           
                            
                          
                          /> */}


                        <FormControl
                          className={`${styles.from_input} ${styles.form_field_wrapperstate}`}
                        >
                          <InputLabel id="demo-simple-select-helper-label">
                            Gender
                          </InputLabel>
                          <Select
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="Select Gender"
                            name="gender"
                            onChange={handleInput}
                            value={user?.gender ? user?.gender : ""}
                            error={error.gender ? true : false}
                          // value={user.select_taxonomy}
                          // onChange={handleInput}
                          // helperText={error.select_taxonomy}
                          >
                            {GenderArray.map((item, key) => {
                              return (
                                <MenuItem className="contact_menu_item" value={item.val} key={key}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                          {error.gender && <FormHelperText id="my-helper-text" >{error.gender}</FormHelperText>}

                        </FormControl>
                         
                          <TextField
                            label="City"
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="city"
                            value={user?.city ? user.city : ""}
                            onChange={handleInput}
                            error={error.city ? true : false}
                            helperText={error.city}
                            onKeyDown={() => { error.city = "" }}
                            // label="Email*"
                            variant="outlined"
                           
                            
                          
                          />
                       
                       
                        {/* <TextField
                          id="outlined-multiline-flexible"
                          label="Massage"
                          name="comments"
                          className={`${styles.from_input} ${styles.form_field_wrappermessage}`}
                          value={user?.comments ? user.comments : ""}
                          onChange={handleInput}
                          error={error.comments ? true : false}
                          helperText={error.comments}
                          onKeyDown={() => {
                            error.comments = "";
                          }}
                          multiline
                          rows={3}
                          maxRows={4}
                        /> */}

                        <FormControl
                          className={`${styles.from_input} ${styles.form_field_wrapperstate}`}
                        >
                          <InputLabel id="demo-simple-select-helper-label">
                            Select State
                          </InputLabel>
                          <Select
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="Select State"
                            name="state"
                            onChange={handleInput}
                            value={user?.state ? user.state : ""}
                            error={error.state ? true : false}
                          // value={user.select_taxonomy}
                          // onChange={handleInput}
                          // helperText={error.select_taxonomy}
                          >
                            {StateArray.map((item, key) => {
                              return (
                                <MenuItem className="contact_menu_item" value={item.val} key={key}>{item.name}</MenuItem>
                              );
                            })}
                          </Select>
                          {error.state && <FormHelperText id="my-helper-text" >{error.state}</FormHelperText>}

                        </FormControl>

                        <TextField
                            label="Zip"
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="zip"
                            value={user?.zip ? user.zip : ""}
                            onChange={handleInput}
                            error={error.zip ? true : false}
                            helperText={error.zip}
                            onKeyDown={() => { error.zip = "" }}
                            // label="Email*"
                            variant="outlined"
                           
                            
                          
                          />
                          <div className={styles.input_wrapper}>
                          <TextField
                            label="Password"
                            type={showpass?'text':'password'}
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="password"
                            value={user?.password ? user.password : ""}
                            onChange={handleInput}
                            error={error.password ? true : false}
                            helperText={error.password}
                            onKeyDown={() => { error.password = "" }}
                            // label="Email*"
                            variant="outlined"
                          />
                          <span className={styles.toggle_btn} onClick={()=>showPass('pass')}>
                            {showpass?<VisibilityIcon/>:<VisibilityOffIcon/>}
                          </span>                          
                          </div>
                          <div className={styles.input_wrapper}>
                          <TextField
                            label="Confirm Password"
                            type={showcpass?'text':'password'}
                            className={`${styles.from_input} `}
                            id="outlined-basic"
                            name="confirm_password"
                            value={user?.confirm_password ? user.confirm_password : ""}
                            onChange={handleInput}
                            error={error.confirm_password ? true : false}
                            helperText={error.confirm_password}
                            onKeyDown={() => { error.confirm_password = "" }}
                            // label="Email*"
                            variant="outlined"
                           
                            
                          
                          />
                          <span className={styles.toggle_btn} onClick={()=>showPass('cpass')}>
                            {showcpass?<VisibilityIcon/>:<VisibilityOffIcon/>}
                          </span>                          
                          </div>
                       


                        <Button
                          className={`${styles.button} ${styles.submitbtnsection}`}
                          variant="contained" onClick={handleSubmit}
                        >
                          Submit
                        </Button>

                        {loader?<LinearProgress />:''}
              </form>

              </div>

            
            </div>

          </div>
          </div>
        </div>


        <div>
          <Snackbar open={snackbarStare} autoHideDuration={6000} onClose={handleClose} className={styles.snackbarwrapper}>
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            {message}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
